"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));

var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));

var _state = _interopRequireDefault(require("@/libs/state"));

var _about = _interopRequireDefault(require("./about.html"));

var firstRun = true;
var ctor = {
  data: function data() {
    return {
      about_open: false
    };
  },
  computed: {
    networks: function networks() {
      return this.$state.networks;
    },
    aboutContent: function aboutContent() {
      return _about.default;
    }
  },
  methods: {
    addNetwork: function addNetwork() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var network = this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      network.showServerBuffer('settings');
    },
    toggleStateBrowser: function toggleStateBrowser() {
      this.$state.$emit('statebrowser.show');
    },
    init: function init() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$state.persistence.watchStateForChanges();

                _this.$emit('start', {
                  fallbackComponent: _this.constructor
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (firstRun) {
                this.init();
                firstRun = false;
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }()
};
var _default = ctor;
exports.default = _default;
(0, _state.default)().getStartups().kiwiirccom = ctor;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["thirdparty"]) window._kiwi_exports["thirdparty"] = {};
window._kiwi_exports["thirdparty"]["kiwiirccom"]
window._kiwi_exports.thirdparty.kiwiirccom = exports.default ? exports.default : exports;
